import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const toggleGroup = css`
  display: inline-flex;
  width: 100%;
`;

export const button = (selected: boolean, iconPosition?: string) => css`
  cursor: ${selected ? 'cursor' : 'pointer'};
  padding: 10px;
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${iconPosition === 'end' ? 'row-reverse' : 'row'};
  gap: 5px;

  line-height: 16px;
  text-align: center;
  letter-spacing: normal;
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.bold};
  color: ${selected ? colors.primary.default : colors.gray.dark};

  border: solid 1px ${selected ? colors.primary.default : colors.gray.light};
  background-color: ${
    selected
      ? colors.shadows.getShadow(colors.primary.default, 0.1)
      : 'transparent'
  };

  ${selected && 'z-index: 1;'};

  > svg {
    color: ${selected ? colors.primary.default : colors.gray.dark};
  }

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:not(:first-child) {
    margin-left: -1px;
  }

  &:hover {
    ${!selected && `background-color: ${colors.custom.lightestGray50};`};
  }

  &:focus {
    outline: none;
  }
`;
